import { render, staticRenderFns } from "./freewayDecision.vue?vue&type=template&id=966ed31a&scoped=true"
import script from "./freewayDecision.vue?vue&type=script&lang=js"
export * from "./freewayDecision.vue?vue&type=script&lang=js"
import style0 from "./freewayDecision.vue?vue&type=style&index=0&id=966ed31a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966ed31a",
  null
  
)

export default component.exports